module.exports = __webpack_public_path__ + "images/5d49c642.img2-chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img2-chs.png
// module id = 384
// module chunks = 0